var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"partners-home"}},[_c('wave-component',{attrs:{"color":"#100E3F"}}),_c('h2',{staticClass:"partners-title text-center pt-5 pb-10"},[_vm._v("Parceiros e Clientes")]),_c('image-moving',{attrs:{"id":"partners-img","image":"partners.png"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }